import { FETCH_ADMINCANIDATES, CURRENT_OPEN_EVENT, FETCH_CANIDATES, SELECTED_CANIDATE, LISTEN_CANIDATES } from '../constants/actionTypes'


const INITIAL_STATE = {
    canidateList: [],
    currentOpenEvent: {},
    canidates: null,
    selectedCanidate: null,
    canidateListener: null,
    canidateIds: null,
}

function adminCanidateReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
      case FETCH_ADMINCANIDATES : {
        return ({
            ...state,
            canidateList: [...action.payload]
          })
      }
    
      case CURRENT_OPEN_EVENT : {
        return ({
          ...state,
          currentOpenEvent: action.payload
        })
    }
        case FETCH_CANIDATES : {
          
            return ({   
                ...state,
                canidates: action.canidatesArr
            })
        }
        case LISTEN_CANIDATES : 
       
        return ({
            ...state,
            canidateIds: action.payload

        })
        case SELECTED_CANIDATE : {
            return ({
                ...state,
                selectedCanidate: action.payload
            })
        }
      
      default : return state;
    }
  }
 
  export default adminCanidateReducer;


// WEBPACK FOOTER //
// ./src/reducers/adminCanidate.js